import { AnimatePresence, motion } from "framer-motion";
import { useFranklinContext } from "../../context/franklin-context";
import { cn } from "../../lib/utils";
import { AIChat } from "../AIChat/ai-chat";
import { Cases } from "../Cases/cases";
import { KnowledgeBase } from "../KnowledgeBase/knowledge-base";
import { SidebarFooter } from "./sidebar-footer";
import { SidebarHeader } from "./sidebar-header";

export function Sidebar() {
  const { isOpen, activeTab } = useFranklinContext();
  const sidebarWidth = "var(--franklin-width, 420px)";

  const renderTabContent = () => {
    switch (activeTab) {
      case "ai":
        return <AIChat />;
      case "knowledge":
        return <KnowledgeBase />;
      case "cases":
        return <Cases />;
      default:
        return <AIChat />;
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.aside
          animate={{ width: sidebarWidth, opacity: 1 }}
          className={cn(
            "franklin-sidebar fixed top-0 right-0 z-[var(--franklin-z-index,9999)] h-full shadow-[0px_25px_50px_-12px_rgba(0,0,0,0.25)]",
            "flex flex-col overflow-hidden"
          )}
          exit={{ width: 0, opacity: 0 }}
          initial={{ width: 0, opacity: 0 }}
          style={{
            maxWidth: "100vw",
            width: sidebarWidth,
            backgroundColor: "var(--franklin-surface)",
            color: "var(--franklin-foreground)",
          }}
          transition={{
            type: "spring",
            damping: 30,
            stiffness: 300,
          }}
        >
          <SidebarHeader />
          <div className="flex-1 overflow-hidden">{renderTabContent()}</div>
          <SidebarFooter />
        </motion.aside>
      )}
    </AnimatePresence>
  );
}
